import React from 'react';
import { EditMode, LayoutServicePageState } from '@sitecore-jss/sitecore-jss/layout';
import { useSitecoreContext } from '../enhancers/withSitecoreContext';
import { getJssPagesClientData } from '@sitecore-jss/sitecore-jss/editing';
/**
 * Renders client scripts and data for editing/preview mode in Pages.
 * This script is only rendered when EditMode is Metadata, otherwise it renders nothing.
 */
export const EditingScripts = () => {
    const { sitecoreContext: { pageState, editMode, clientData, clientScripts }, } = useSitecoreContext();
    // Don't render anything if not in editing/preview mode
    if (pageState === LayoutServicePageState.Normal || pageState === LayoutServicePageState.Preview) {
        return React.createElement(React.Fragment, null);
    }
    if (editMode === EditMode.Metadata) {
        const jssClientData = Object.assign(Object.assign({}, clientData), getJssPagesClientData());
        return (React.createElement(React.Fragment, null, clientScripts === null || clientScripts === void 0 ? void 0 :
            clientScripts.map((src, index) => (React.createElement("script", { src: src, key: index }))),
            Object.keys(jssClientData).map((id) => (React.createElement("script", { key: id, id: id, type: "application/json", dangerouslySetInnerHTML: { __html: JSON.stringify(jssClientData[id]) } })))));
    }
    return React.createElement(React.Fragment, null);
};
